<template>
<div v-if="visibility" class="m-t-10"> 
  <div>
    <b-row>

      <!-- Incoterm -->
      <b-col cols="3">
        <section class="input-values">
          <span :ref="`incoterm-${orderInState.order_id}`"><i class="fa fa-check" aria-hidden="true"></i></span>
          <b-input-group size="sm" class="mb-2">
            <b-input-group prepend="Incoterm">
              <b-form-input v-model="orderInState.incoterm" debounce="500"  :data-id="orderInState.order_id" :data-field="'incoterm'" :data-table="'order'" @input="updateSingleOrderRelatedValue" @focus="getValuesForUpdate"></b-form-input>
            </b-input-group>
          </b-input-group>
        </section>
      </b-col>

      <!-- DHL Service -->
      <b-col cols="3">
        <section class="input-values">
          <span :ref="`dhlService-${orderInState.order_id}`"><i class="fa fa-check" aria-hidden="true"></i></span>
          <b-input-group size="sm" class="mb-2">
            <b-input-group prepend="DHL Service">
              <b-form-input v-model="orderInState.dhl_service" debounce="500" 
              :data-id="orderInState.order_id" :data-field="'dhlService'" :data-table="'order'"
              @input="updateSingleOrderRelatedValue" @focus="getValuesForUpdate"></b-form-input>
            </b-input-group>
          </b-input-group>
        </section>
      </b-col>

      <!-- Total Weight -->
      <b-col cols="3">
        <section class="input-values">
          <span :ref="`weightTakenAfterPackaging-${orderInState.order_id}`"><i class="fa fa-check" aria-hidden="true"></i></span>
          <b-input-group size="sm" class="mb-2">
            <b-input-group prepend="Total Weight">
              <b-form-input v-model="orderInState.weightTakenAfterPackaging" debounce="500"
              :data-id="orderInState.order_id" :data-field="'weightTakenAfterPackaging'" :data-table="'order'"
              @input="updateSingleOrderRelatedValue" @focus="getValuesForUpdate"></b-form-input>
            </b-input-group>
          </b-input-group>
        </section>
      </b-col>

      <b-col cols="3">
        <section class="input-values">
          <span :ref="`province-${orderInState.order_id}`"><i class="fa fa-check" aria-hidden="true"></i></span>
          <b-input-group size="sm" class="mb-2">
            <b-input-group prepend="Ship. State">
              <b-form-input v-model="orderInState.shippingState" debounce="500"
              :data-id="orderInState.order_id" :data-field="'province'" :data-table="'ShopifyShippingAddress'"
              @input="updateSingleOrderRelatedValue" @focus="getValuesForUpdate"></b-form-input>
            </b-input-group>
          </b-input-group>
        </section>
      </b-col>

    </b-row>
    <b-row>
      <b-col>
         <section class="input-values">
          <span :ref="`packageDesc-${orderInState.order_id}`"><i class="fa fa-check" aria-hidden="true"></i></span>
          <b-input-group size="sm" class="mb-2">
            <b-input-group prepend="Package Description">
              <b-form-input v-model="orderInState.packageDesc" debounce="500"
              :data-id="orderInState.order_id" :data-field="'packageDesc'" :data-table="'order'"
              @input="updateSingleOrderRelatedValue" @focus="getValuesForUpdate"></b-form-input>
            </b-input-group>
          </b-input-group>
        </section>
      </b-col>
    </b-row>
  </div>
  <b-table striped bordered hover :items="orderItemsInState" :fields="fields" head-variant="light">
    <template v-slot:cell(name)="data">
      <div class="item-name">
        {{ data.value }}
      </div>
    </template>
    <template v-slot:cell(id)="data">
      
      <section class="input-values">
        <span :ref="`hsCode-${data.item.id}`"><i class="fa fa-check" aria-hidden="true"></i></span>
        <b-input-group size="sm" class="mb-2">
          <b-input-group prepend="HS Code">
            <b-form-input  v-model="data.item.hsCode" debounce="500"
            :data-id="data.item.id" :data-field="'hsCode'" :data-table="'order_item'"
            @input="updateSingleOrderRelatedValue" @focus="getValuesForUpdate"></b-form-input>
          </b-input-group>
        </b-input-group>
      </section>

      <section class="input-values">
        <span :ref="`setPrice-${data.item.id}`"><i class="fa fa-check" aria-hidden="true"></i></span>
        <b-input-group size="sm" class="mb-2">
          <b-input-group prepend="Set Price">
            <b-form-input v-model="data.item.setPrice" debounce="500" 
            :data-id="data.item.id" :data-field="'setPrice'" :data-table="'order_item'"
            @input="updateSingleOrderRelatedValue" @focus="getValuesForUpdate" max="50"></b-form-input>
          </b-input-group>
        </b-input-group>
      </section>
    </template>
  </b-table>
</div>
</template>

<script>
import OrdersService from '../../services/orders.service';
import EventBus from '../../EventBus';
import { debounce } from "debounce";

export default {
  data() {
    return {
      fields: [{
          key: 'name',
          label: 'Name'
        },
        {
          key: 'id',
          label: 'Variables'
        },
        {
          key: 'price',
        },
        {
          key: 'quantity'
        },
        {
          key: 'sku'
        },
      ],
      orderInState: this.order,
      orderItemsInState: this.items,
      updateData: {}
    }
  },
  props: {
    visibility: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    order:{
      type: Object,
      default: () => {}
    }
  },
  watch: {
    order: function(val){
      this.orderInState = val;
    },
    items: function(val){
      this.orderItemsInState = val;
    }
  },
  methods: {
    valueToUpdate(id, field, table){
      
      this.updateData = {
        id, field, table
      }
      console.log(this.updateData);
    }, 
    updateSingleOrderRelatedValue: debounce(function(value) {
       
       this.updateData.value = value;
       OrdersService.singleValueUpdateOrderAndItems(this.updateData)
        .then(response => {
           let updatedMsg = this.$refs[`${this.updateData.field}-${this.updateData.id}`];
           updatedMsg.classList.add("animated");


              setTimeout(() => {
                    updatedMsg.classList.remove("animated");
              }, 2000);
              

                // Update the data
                let orderWithItems = {
                    id: this.orderInState.order_id,
                    incoterm: this.orderInState.incoterm,
                    dhlService: this.orderInState.dhl_service,
                    weightTakenAfterPackaging: this.orderInState.weightTakenAfterPackaging,
                    packageDesc: this.orderInState.packageDesc,
                    shippingState: this.orderInState.shippingState,
                    ShopifyOrderItems: this.orderItemsInState
                }

                EventBus.$emit('orders.update-single-order-data-each-ship-validation', orderWithItems);

                
                // Check if all filled then fire event to remove error message;
                let allFilled = true;
                // Check if everything is filled up
                if(!this.orderInState.incoterm || !this.orderInState.dhl_service || !this.orderInState.weightTakenAfterPackaging || !this.orderInState.packageDesc){
                    allFilled = false;
                }
                this.orderItemsInState.forEach(item => {
                   if(!item.hsCode || !item.setPrice){
                     allFilled = false;
                   }
                })

                if(allFilled){
                  console.log('We are good to go');
                  EventBus.$emit('orders.remove-shipping-empty-field-error', this.orderInState.order_id);
                }

            
        })
        .catch(errors => console.log(errors.response.data))
    }, 500),
    getValuesForUpdate(e){
      const {id, field, table} = e.target.dataset;
      this.updateData = {
        id, field, table
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table td,
.table th {
  white-space: normal;
}

.item-name {
  line-height: 1.5em;
}

.input-values {
  max-width: 1000px;
  position: relative;
  vertical-align: middle;
  .input-group-text {
    background-color: rgb(238, 237, 237);
    padding-left: 4px;
    padding-right: 4px;
  }
  span{
    position: absolute;
    right: 5px;
    top: 8px;
    font-size: 12px;
    z-index: 999;
    color: rgb(34, 202, 84);
    opacity:0;
    transition: all 300ms ease;
  }
  span.animated{
    animation: blink 1s linear infinite;
  }
  @keyframes blink{
    0%{opacity: 0;}
    50%{opacity: 1;}
    100%{opacity: 0;}
   }
}

.input-group {
  border: 0.5px solid rgb(236, 236, 236);
}
</style>
